import { render, staticRenderFns } from "./edit_facture.vue?vue&type=template&id=90a6a7ca&scoped=true&"
import script from "./edit_facture.vue?vue&type=script&lang=js&"
export * from "./edit_facture.vue?vue&type=script&lang=js&"
import style0 from "./edit_facture.vue?vue&type=style&index=0&id=90a6a7ca&lang=scss&scoped=true&"
import style1 from "./edit_facture.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a6a7ca",
  null
  
)

export default component.exports